import {ApiService, handlerError} from "../ApiService";
import {getSendData, readData, responseChat} from "./transform/ChatTransform";

const ChatService = {};

ChatService.get = (grupoid) => {
  return ApiService.post('', {tipo: "OPERACION_15-1", id_grupo: grupoid})
    .then(responseChat)
    .catch(handlerError);
}

ChatService.sendMessage = (message, grupoid) => {
  return ApiService.post('', getSendData(message, grupoid))
    .then()
    .catch(handlerError);
}

ChatService.readMessages = (chat, grupoid) =>
  ApiService.post('', readData(chat, grupoid))
    .catch(handlerError);


export default ChatService